module.exports = __webpack_public_path__ + "fonts/digifaw.d9ba300b.ttf";